const HotDog = [
  {
    id: 1,
    title: "Hot Dog Max",
    thumb: "./assets/data_images/hotDog.png",
    price: 8,
  },
  {
    id: 2,
    title: "Hot Dog Passion",
    thumb: "./assets/data_images/hotDog.png",
    price: 10,
  },
  {
    id: 3,
    title: "Tex Mex Hot Dog",
    thumb: "./assets/data_images/hotDog.png",
    price: 12,
  },
  {
    id: 4,
    title: "Space Hot Dog",
    thumb: "./assets/data_images/hotDog.png",
    price: 11,
  },
  {
    id: 5,
    title: "Mega Cheese hotDog",
    thumb: "./assets/data_images/hotDog.png",
    price: 18,
  },
];

export default HotDog;
